import { render, staticRenderFns } from "./MerchantList.vue?vue&type=template&id=41280201&"
import script from "./MerchantList.vue?vue&type=script&lang=ts&"
export * from "./MerchantList.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantList.vue?vue&type=style&index=0&id=41280201&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports